/*
 * @Description:
 * @Author: WangYuhan
 * @Date: 2022-11-02 16:57:25
 * @LastEditTime: 2023-10-09 15:06:17
 * @LastEditors: WangYuhan
 */
const state = {
  isAutoRoute: false,
  whetherUpdateWaybill: 1,
};

// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {
  // 更新数据
  updateIsauto(state, payload) {
    state.isAutoRoute = payload;
  },
  upWhetherUpdateWaybill: (state, token) => {
    state.whetherUpdateWaybill = token;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
